/* ------------------------------------------------------------------------- */
/*	Helper Variables & Functions
/*  NOTE: This code needs to be completely refactored
/* ------------------------------------------------------------------------- */

import $ from 'jquery';

import '../vendor/responsive.core';
import '../vendor/responsive.modal';
import '../vendor/responsive.tablelist';

(function($) {
  // If JavaScript is enabled, remove a class `no-js`
  // and replace with a class `js`
  $('html').toggleClass('no-js js');

  var $body = $('body');
  /**
   * Bind click events for all the `[data-action]` elements
   */
  var actions = {};

  $body.on('click', '[data-action]', function( event ) {
    var action = $(this).data('action').split(' ');

    for( var a = 0; a < action.length; a++ ) {
      if( action[a] in actions )
        actions[action[a]].call(this, event);
    }
  });
  /* eslint-enable */

  $('body').on('click', '.js-link-parent', function() {
    const $link = $(this).find('.js-link');
    if ($link.length) {
      const target = $link.attr('target');
      const url = $link.attr('href');

      if (target === '_blank') {
        window.open(url, '_blank').focus();
      } else {
        document.location.href = url;
      }
    }
  });

  /* ------------------------------------------------------------------------- */
  /*  Toggler Buttons
  /* ------------------------------------------------------------------------- */

  $body.on('click', 'button', function() {
    var $this = $(this);

    for ( var prop in $(this).data() ) {
      if ( prop.indexOf('toggler') === 0 ) {
        var className = 'is-toggled';

        // Custom class name
        if( $this.is('[data-toggler-class]') )
          className = $this.attr('data-toggler-class');

        $this.toggleClass( className );

        // Toggle other elements as well
        if( $this.is('[data-toggler-target]') )
          $( $this.attr('data-toggler-target') )
            .toggleClass( className , $this.hasClass( className ));
      }
    }
  });


  /* ------------------------------------------------------------------------- */
  /*  Content
  /* ------------------------------------------------------------------------- */

  /**
   * Basic full screen modal window
   */
  $('.js-open-modal').modal({
    closeText: '<i class="icon -i-close"></i>',
    lock: false
  });

  /**
   * Smaller "popup" modal window
   * @param {Event} e - The event object
   */
  actions.openPopup = function(e) {
    var $this = $(this);

    $this.modal({
      closeText: '<i class="icon -i-close"></i>',
      cssClass: $this.data('css-class') || '-padding-none',
      closeFixedPosition: false,
      fitViewport: false,
      lock: false,
      target: $this.data('target')
    });

    e.preventDefault();

    // (because otherwise they won't work, for some reason)
    if (!$this.data('initialized')) {
      $this.data('initialized', true);
      $this.trigger('click');
    }
  };

  // (because otherwise they won't work, for some reason)
  //$('[data-action="openPopup"]').trigger('click');

  // Make "fake" buttons accessible
  $('[data-action="openPopup"][role="button"]').on('keypress', function( e ) {
    // 13 = Enter
    if(e.code && e.code === 13)
      $(this)[0].click();
  });

  /**
   * Close popup
   * @param {object} e - event object
   */
  actions.closePopup = function(e) {
    $(this).closest('.modal-overlay').find('.modal-close').trigger('click');

    e.preventDefault();
  }
})($);
